export default __webpack_public_path__ + "static/media/cart-02.75be14b0.jpg";